import { calculateItemStatus } from './patternEngine'

// ─── Types ────────────────────────────────────────────────────────────────────

export interface RestockItem {
  id:         string
  name:       string
  emoji:      string
  avgPrice:   number
  status:     string
  [key: string]: unknown
}

export interface RestockSummary {
  urgentItems:    RestockItem[]
  lowItems:       RestockItem[]
  estimatedTotal: number
  itemCount:      number
}

// ─── calculateRestockSummary ──────────────────────────────────────────────────

export function calculateRestockSummary(
  pantryItems:   any[],
  confirmations: any[],
): RestockSummary {
  const urgentItems: RestockItem[] = []
  const lowItems:    RestockItem[] = []

  for (const item of pantryItems) {
    if (!item.is_active) continue

    const { status, daysRemaining } = calculateItemStatus(
      item.last_confirmed_at ? new Date(item.last_confirmed_at) : null,
      item.avg_restock_cycle_days,
      item.confirmation_count,
    )

    // Average price from all known confirmations for this item
    const itemConfs = confirmations.filter(c => c.item_id === item.id && c.price_paid)
    const avgPrice  = itemConfs.length > 0
      ? itemConfs.reduce((sum, c) => sum + c.price_paid, 0) / itemConfs.length
      : 0

    if (status === 'red' || item.status_override === 'out' || item.status_override === 'used') {
      urgentItems.push({ ...item, avgPrice, status })
    } else if (status === 'amber' && daysRemaining <= 3) {
      lowItems.push({ ...item, avgPrice, status })
    }
  }

  const allItems       = [...urgentItems, ...lowItems]
  const estimatedTotal = allItems.reduce((sum, i) => sum + (i.avgPrice || 0), 0)

  return { urgentItems, lowItems, estimatedTotal, itemCount: allItems.length }
}

// ─── isShoppingEve ────────────────────────────────────────────────────────────

export function isShoppingEve(shoppingDay: number): boolean {
  const todayDay = new Date().getDay()
  const eve      = shoppingDay === 0 ? 6 : shoppingDay - 1
  return todayDay === eve
}

// ─── isShoppingDay ────────────────────────────────────────────────────────────

export function isShoppingDay(shoppingDay: number): boolean {
  return new Date().getDay() === shoppingDay
}
